import { useQuery } from "@apollo/client";

import { GET_OAUTH_REDIRECT_ALLOWLIST } from "./gql";

const useGetOauthRedirectAllowlist = () => {
  const { data, loading, error } = useQuery(GET_OAUTH_REDIRECT_ALLOWLIST);

  return {
    allowedHosts: data?.oauthRedirectAllowedHosts,
    loading,
    error,
  };
};

export default useGetOauthRedirectAllowlist;
